<ng-container>
	@if (headline) {
		<span translate="{{ headline }}" class="h1 dialog-title"></span>
	}
	<div class="options">
		@if (!startOptions.length && translateNone) {
			<p class="empty" translate="{{ translateNone }}"></p>
		}

		@if (startOptions.length) {
			<div class="wrapper">
				@for (option of startOptions; track option) {
					<article class="option" [ngClass]="option.classes">
						<header>
							<div class="wrapper">
								<span class="h5" translate="{{ option.title }}"></span>
								<i class="{{ option.icon }}"></i>
							</div>
						</header>
						<p translate="{{ option.message }}"></p>
						<footer>
							<button
								class="button lg"
								(click)="option.on()"
								translate="{{ option.button }}"
								[disabled]="option.disabled"
							></button>
						</footer>
					</article>
				}
			</div>
		}
	</div>
</ng-container>
